/*
Raghu  26/10/2022   3075154998   Table Enhancements
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
akhila 11/01/2022 3075154998 TablePagination bugFix
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fixes
Dilip 11/03/2022  3075154998 added code to delete popup

*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {TablePagination} from '@material-ui/core';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function ConditionTable({
  conditionData,
  setConditionData,
  setIsConditionEditMode,
  setConditionRowData,
  setConditionCode,
}) {
  const columns = [
    {
      title: 'Code',
      field: 'code',
      cellStyle: {maxWidth: 500},
      minWidth: '300px',
    },
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        conditionData[rowData?.tableData?.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'To Field',
      field: 'toField',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Expression',
      field: 'operator',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Date Format',
      field: 'dateFormat',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
  ];
  const [rows, setRows] = useState(defaultRows);
  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const tableDataCondition = conditionData ?
    conditionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];

  const handleConditionEdit = (rowData) => {
    setIsConditionEditMode(true);
    setConditionRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setTimeout(() => {
      const data = [...conditionData];
      const newData = data.filter(
        (row, i) =>
          row.toField !== deleteData.toField ||
          row.srcField !== deleteData.srcField ||
          row?.operator?.id !== deleteData?.operator?.id ||
          row.dateFormat !== deleteData.dateFormat,
      );
      setConditionData(newData);
    }, 1000);
    setIsDelete(false);
  };
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Condition"
        value={`Are you sure you want to delete this ${deleteData?.code} condition?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={tableDataCondition}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer ">
                <div className="mt-2">

                </div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
          }}
          actions={[
            {
              icon: () => <EditOutlinedIcon/>,
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                handleConditionEdit(rowData);
                setConditionCode(rowData.id);
              },
            },
            {
              icon: () => <DeleteOutlineOutlinedIcon/>,
              tooltip: 'Delete',
              onClick: (event, rowData) => {
                handleDelete(rowData);
                setIsDelete(true);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
